import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

const SidebarLayoutContext = createContext<{
  width: number;
  setSidebar: (element: HTMLDivElement | null) => void;
}>({ width: 0, setSidebar: () => {} });

export function SidebarLayoutProvider({ children }: { children: ReactNode }) {
  const [sidebar, setSidebar] = useState<HTMLDivElement | null>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!sidebar) {
      setWidth(0);
      return;
    }
    const measure = () => setWidth(sidebar.getBoundingClientRect().width);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(sidebar);
    return () => observer.disconnect();
  }, [sidebar]);

  return (
    <SidebarLayoutContext.Provider value={{ width, setSidebar }}>
      {children}
    </SidebarLayoutContext.Provider>
  );
}

export const useSidebarLayout = () => useContext(SidebarLayoutContext);
